// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

/** The button shape of the active skin: corner, border and label. Values live in theme/skins/<name>.ts. */
export const appButton = activeSkin.button;

export default appButton;
